import {
    forgotPasswordRequest,
    getAccountByIdRequest,
    loginRequest,
    logoutRequest,
    newPhoneRequest,
    newPasswordRequest,
    signupRequest,
    completeGoogleRequest
} from '../../../services/network/auth';
class AccountService {
    async login(credentials) {
        return await loginRequest(credentials);
    }

    async signUp(credentials) {
        return await signupRequest(credentials);
    }

    async logout(accountId) {
        return await logoutRequest(accountId);
    }

    async getAccountById(accountId) {
        return await getAccountByIdRequest(accountId);
    }

    async forgotPassword(email) {
        return await forgotPasswordRequest(email);
    }

    async newPassword(values) {
        return await newPasswordRequest(values);
    }

    async newPhone(values) {
        return await newPhoneRequest(values);
    }

    async completeGoogle(values) {
        return await completeGoogleRequest(values);
    }
}

export const AuthService = new AccountService();
